import { CommanderOrigin } from '@mews-commander/data-access';
import { enumify, Enumify } from '@mews/enumify';

function ManualOrigin() {}

enumify<CommanderOrigin, number>(ManualOrigin, 'ManualOrigin', {
    InPerson: 0,
    Channel: 1,
    Phone: 3,
    Email: 4,
    Website: 7,
    Message: 8,
    CallCenter: 9,
});

export default ManualOrigin as unknown as Enumify<CommanderOrigin, number>;
